import React from 'react';

import SingleSelect from './SingleSelect';

type Props = React.SelectHTMLAttributes<HTMLSelectElement>;

const Select: React.FC<Props> = ({ className, children, value, onChange, disabled }) => {
  const classes = [className].filter(Boolean).join(' ');
  const forceOpenUp = Boolean(className && className.split(' ').includes('pagination-size'));
  const panelMinWidth = forceOpenUp ? 63 : undefined;
  const disablePanelMaxHeight = forceOpenUp;
  const flushToTriggerTop = forceOpenUp;

  const options = React.useMemo(() => {
    return React.Children.toArray(children)
      .map((node) => {
        if (!React.isValidElement(node)) return null;
        if (typeof node.type !== 'string') return null;
        if (node.type.toLowerCase() !== 'option') return null;

        const optValue = (node.props as { value?: string | number }).value;
        const label = node.props.children;
        return {
          value: optValue === undefined ? '' : String(optValue),
          label: typeof label === 'string' ? label : String(label ?? ''),
        };
      })
      .filter(Boolean) as Array<{ value: string; label: string }>;
  }, [children]);

  const currentValue = value === undefined ? '' : String(value);

  return (
    <SingleSelect
      className={classes}
      value={currentValue}
      disabled={disabled}
      forceOpenUp={forceOpenUp}
      panelMinWidth={panelMinWidth}
      disablePanelMaxHeight={disablePanelMaxHeight}
      flushToTriggerTop={flushToTriggerTop}
      onChange={(next) => {
        if (!onChange) return;
        onChange({ target: { value: next } } as unknown as React.ChangeEvent<HTMLSelectElement>);
      }}
      options={options}
    />
  );
};

export default Select;
